import { QueovalBase } from '../global';
import { Select } from '../utilities';

export class TagModel extends QueovalBase {
  public idPere: string;
  public relation: string;
  public tags: Array<string>;
  public allTags: Array<string>;
  public filteredTag: Array<string>;
  public listIdPere: Array<string>;
  public listSelectedTag: Array<Select>;
  constructor() {
    super();
    this.tags = new Array<string>();
    this.allTags = new Array<string>();
    this.filteredTag = new Array<string>();
    this.listIdPere = new Array<string>();
    this.listSelectedTag = new Array<Select>();
    this.idPere = '';
  }
}
